export var guardNSigns = function guardNSigns(n) {
  return function (value) {
    return value.split('').slice(0, n).join('');
  };
};